const Learner = () =>
    import ('@/components/Learner/Learner');
const Notification = () =>
    import ('@/components/Learner/Notification');
const   Messages = () =>
    import ('@/components/Learner/Messages');
const Profile = () =>
    import ('@/components/Learner/Profile');
const MyCalendar = () =>
    import ('@/components/Learner/MyCalendar');
const CommonDiscussionForum = () =>
    import ('@/components/Learner/CommonDiscussionForum');
    const LearnerProfileTabs = () =>
    import ('@/components/Learner/LearnerProfileTabs');
const Skills = () =>
    import ('@/components/Learner/LearnerSkills');
const LearnerTransactions = () =>
    import ('@/components/Learner/LearnerTransactions');
const LearnerCertificate = () =>
    import ('@/components/Learner/LearnerCertificate');
const LearnerSettings = () =>
    import ('@/components/Learner/LearnerSettings');
const MyCourses = () =>
    import ('@/components/Learner/LearnerCourseDashboard/MyCourses');
const Sample = () =>
    import ('@/components/Learner/LearnerCourseDashboard/Sample');
const ContactSupport = () =>
    import ('@/components/Learner/LearnerCourseDashboard/ContactSupport');
// import Learner from '@/components/Learner/Learner'
// import Profile from '@/components/Learner/Profile'
// import Skills from '@/components/Learner/LearnerSkills'
// import MyCourses from '@/components/Learner/LearnerCourseDashboard/MyCourses'

//LearnerCourseData
const FillTheGapAssignment = () =>
    import ('@/components/Learner/LearnerCourse/FillTheGapAssignment')
const LearnerCourseData = () =>
    import ('@/components/Learner/LearnerCourse/LearnerCourseData');
const JoinNewCourse = () =>
    import ('@/components/Learner/LearnerCourse/JoinNewCourse');
const VideoTrainingLearner = () =>
    import ('@/components/Learner/VideoTrainingLearner');
const CoursesCatalog = () =>
    import ('@/components/Learner/CoursesCatalog');
const CoursePurchase = () => import('@/components/Purchase/CoursePurchase');   
const CourseOverview = () =>
    import ('@/components/Learner/CourseOverview');
const Overview = () =>
    import ('@/components/Learner/LearnerCourse/Overview');
const LearnerDiscussionForum = () =>
    import ('@/components/Learner/LearnerCourse/LearnerDiscussionForum');
const CourseContents = () =>
    import ('@/components/Learner/LearnerCourse/CourseContents');
const CourseMaterial = () =>
    import ('@/components/Learner/LearnerCourse/CourseMaterial');
const ContentMenu = () =>
    import ('@/components/Learner/LearnerCourseContent/ContentMenu');     
const Lecture_Webinar = () =>
    import ('@/components/Learner/LearnerCourse/Lecture&Webinar');
const CourseNotices = () =>
    import ('@/components/Learner/LearnerCourse/Notices');
const Test = () =>
    import ('@/components/Learner/LearnerCourse/Test');
const LearnerAssignment = () =>
    import ('@/components/Learner/LearnerCourse/LearnerAssignment');
const MCQAssignment = () =>
    import ('@/components/Learner/LearnerCourse/MCQAssignment')
const SingleWordAnswer = () =>
    import ('@/components/Learner/LearnerCourse/SingleWordAnswer')
const SubjectiveAssignment = () =>
    import ('@/components/Learner/LearnerCourse/SubjectiveAssignment')
const HandOnAssignment = () =>
    import ('@/components/Learner/LearnerCourse/HandOnAssignment')
const MatchThePair = () =>
    import ('@/components/Learner/LearnerCourse/MatchThePair')
const CieAssignment = () =>
    import ('@/components/Learner/LearnerCourse/CieAssignment')
const TestResult = () =>
    import ('@/components/Learner/LearnerCourse/TestResult');
const LearnerCourseCertificate = () =>
    import ('@/components/Learner/LearnerCourse/LearnerCourseCertificate');
const StartExam = () =>
    import ('@/components/Learner/LearnerTest/StartExam');
const Result = () =>
    import ('@/components/Learner/LearnerTest/Result');
const ChangePassword = () =>
    import ('@/components/Learner/ChangePassword');
const Changepwd = () =>
    import ('@/components/Learner/Changepwd');
const Redistest = () =>
    import ('@/components/Learner/Redistest');
const Progress = () => import ('@/components/Learner/LearnerProgress/Progress');
const CourseProgress = () => import ('@/components/Learner/LearnerProgress/CourseProgress');
const PlatformFeedback = () => import ('@/components/Learner/PlatformFeedback');
const LearnerSurveys = () => import ('@/components/Learner/LearnerSurveys');
const LearnerSurveyTest = () => import ('@/components/Learner/LearnerSurveyTest');
const CourseContentVideo = () =>
    import ('@/components/MediaPlayer/VideoPlayer');

const CareerJet = () => import ('@/components/Learner/Jobs/CareerJet');    
const LearnerJobs = () => import ('@/components/Learner/Jobs/LearnerJobs');    
const Linkedin = () => import ('@/components/Learner/Jobs/Linkedin');  
const Review = () =>  import ('@/components/Learner/Review/Review'); 
const Contact_Support = () => import('@/components/Learner/ContactSupport');
//import Overview from '@/components/Learner/LearnerCourse/Overview'
//import CourseContents from '@/components/Learner/LearnerCourse/CourseContents'
//import Lecture_Webinar from '@/components/Learner/LearnerCourse/Lecture&Webinar'
//import CourseNotices from '@/components/Learner/LearnerCourse/Notices'
//import Test from '@/components/Learner/LearnerCourse/Test'
//import TestResult from '@/components/Learner/LearnerCourse/TestResult'
// import StartExam from '@/components/Learner/LearnerTest/StartExam'
// import Result from '@/components/Learner/LearnerTest/Result'
// import ChangePassword from '@/components/Learner/ChangePassword'
// import Changepwd from '@/components/Learner/Changepwd'

const ResumeBuilding = () =>  import('@/components/Learner/Resume/ResumeBuilding'); 
const PersonalDeatils = () => import('@/components/Learner/Resume/PersonalDeatils'); 
const AddressDetails = () => import('@/components/Learner/Resume/AddressDetails'); 
const Academic = () => import('@/components/Learner/Resume/Academic'); 
const InternshipProject = () => import('@/components/Learner/Resume/InternshipProject');
const SkillCertification = () => import('@/components/Learner/Resume/SkillCertification');
const Experience = () => import('@/components/Learner/Resume/Experience');
const ExtraCurricular =() => import('@/components/Learner/Resume/ExtraCurricular');
const Publication = () => import('@/components/Learner/Resume/Publication');
const Social = () =>  import('@/components/Learner/Resume/Social');
const routes = [
    {
        path: '/courses-catalog-rssdi',
        name: 'courses-catalog-rssdi',
        meta: { breadcrumb: 'Courses Catalog' },
        component: CoursesCatalog,
    },
    {
        path: '/learner',
        name: 'learner',
        component: Learner,
        meta: { breadcrumb: 'Dashboard' },
        props: true,

        children: [{
                path: 'my-courses',
                name: 'my-courses',
                component: MyCourses,
                meta: { breadcrumb: 'My Courses' },
                children: [{
                    path: '/learner-course-data',
                    name: 'learner-course-data',
                    // meta: { breadcrumb:"Course"},
                    //working meta: { breadcrumb: router => `Course:${router.id}` },
                    // meta: { breadcrumb: (this.$route) => `Course:${this.$route}` },
                    // meta: { 
                    //   breadcrumb: {
                    //   label: 'Parent to Params',
                    //   parent: 'Params'
                    //   }
                    // },
                    //   meta: {
                    //     breadcrumb() {
                    //         const  name  = this.$route.params.id;
                    //         console.log(this.$route)
                    //         console.log(this.$route.params)
                    //         return name;
                    //     }
                    //  },
                    component: LearnerCourseData,
                    children: [
                        {
                            path: '/learner-course-overview',
                            name: 'learner-course-overview',
                            meta: { breadcrumb: router => `${router.id} / Overview` },
                            component: Overview,
                        },
                        {
                            path: '/learner-discussion-forum',
                            name: 'learner-discussion-forum',
                            meta: { breadcrumb: router => `${router.id} / Discussion Forum` },
                            component: LearnerDiscussionForum,
                        },
                        {
                            path: '/course-certificate',
                            name: 'course-certificate',
                            meta: { breadcrumb: router => `${router.id} / Certificate` },
                            component: LearnerCourseCertificate,
                        },
                        {
                            path: '/platform-feedback-learner',
                            name: 'platform-feedback-learner',
                            //meta: { breadcrumb: router => `${router.id}`},
                            component: PlatformFeedback,
                        },
                        {
                            path: '/learner-survey',
                            name: 'learner-survey',
                            //meta: { breadcrumb: router => `${router.id}`},
                            component: LearnerSurveys,
                        },
                        {
                            path: '/learner-contact-support',
                            name: 'learner-contact-support',
                            component: Contact_Support,
                            meta: { breadcrumb: router =>`Contact Support` },
                
                        },
                        {
                            path: '/learner-survey-test',
                            name: 'learner-survey-test',
                            //meta: { breadcrumb: router => `${router.id}`},
                            component: LearnerSurveyTest,
                        },
                        {
                            path: '/learner-course-content',
                            name: 'learner-course-content',
                            meta: { breadcrumb: router => `${router.id} / Course Content` },
                            component: CourseContents,
                        },
                        {
                            path: '/learner-course-material',
                            name: 'learner-course-material',
                            meta: { breadcrumb: router => `${router.id} / Course Material` },
                            component: CourseMaterial,
                        },
                        ////////////////////////////////Content data
                        {
                            path: '/learner-course-content-menu',
                            name: 'learner-course-content-menu',
                            meta: { breadcrumb: router => `${router.id} / Course Content Menu` },
                            component: ContentMenu,
                            children:[
                                {
                                    path: '/learner-course-content-video-player/:id',
                                    name: 'learner-course-content-video-player',
                                    component: CourseContentVideo,
                                }
                            ]
                        },
                        //////////////////////////////////////
                        {
                            path: '/learner-lecture-webinar',
                            name: 'learner-lecture-webinar',
                            meta: { breadcrumb: router => `${router.id} / Lecture & Webinar` },
                            component: Lecture_Webinar,
                        },
                        {
                            path: '/learner-course-notices',
                            name: 'learner-course-notices',
                            meta: { breadcrumb: router => `${router.id} / Announcements` },
                            component: CourseNotices,
                        },
                        {
                            path: '/learner-course-test',
                            name: 'learner-course-test',
                            meta: { breadcrumb: router => `${router.id} / Test` },
                            // meta: { breadcrumb: 'Test' },
                            component: Test,
                        },
                        {
                            path: '/learner-assignment',
                            name: 'learner-assignment',
                            meta: { breadcrumb: router => `${router.id} / LearnerAssignment` },
                            component: LearnerAssignment,
                        },
                        {
                            path: '/learner-mcq-assignment',
                            name: 'learner-mcq-assignment',
                            meta: { breadcrumb: `Assignment / MCQ ` },
                            component: MCQAssignment,
                        },
                        {
                            path: '/learner-singleword-assignment',
                            name: 'learner-singleword-assignment',
                            meta: { breadcrumb: `Assignment / SingleWordAnswer ` },
                            component: SingleWordAnswer,
                        },
                        {
                            path: '/learner-subjective-assignment',
                            name: 'learner-subjective-assignment',
                            meta: { breadcrumb: `Assignment / Subjective` },
                            component: SubjectiveAssignment,
                        },
                        {
                            path: '/learner-cie-assignment',
                            name: 'learner-cie-assignment',
                            meta: { breadcrumb: `Assignment / CIE` },
                            component: CieAssignment,
                        },
                        {
                            path: '/learner-handson-assignment',
                            name: 'learner-handson-assignment',
                            meta: { breadcrumb: `Assignmemt / Hands On Assignment` },
                            component: HandOnAssignment,
                        },
                        {
                            path: '/learner-matchthepair-assignment',
                            name: 'learner-matchthepair-assignment',
                            meta: { breadcrumb:  `Assignmemt  / Match The Pair` },
                            component: MatchThePair,
                        },
                        {
                            path: '/learner-course-test-result',
                            name: 'learner-course-test-result',
                            meta: { breadcrumb: router => `${router.id} / Result` },
                            component: TestResult,
                        },
                        {
                            path: '/learner-fillGap-assignment',
                            name: 'learner-fillGap-assignment',
                            meta: { breadcrumb: `Assignmemt  / Fill The Gap` },
                            component: FillTheGapAssignment,
                        },
                        {
                            path: '/learner-review',
                            name: 'learner-review',
                            meta: { breadcrumb: router => `${router.id} / Review` },
                            component: Review
                        },
                    ]
                },
             ], 
            },
            {
                path: '/learner-resume-building',
                name: 'learner-resume-building',
                component: ResumeBuilding,
                meta: { breadcrumb: 'ResumeBuilding' },
            },
            {
                path: '/learner-personal-details',
                name: 'learner-personal-details',
                component: PersonalDeatils,
            },
            {
                path: '/learner-address-details',
                name: 'learner-address-details',
                component: AddressDetails
            },
            {
                path: '/learner-academic-details',
                name: 'learner-academic-details',
                component: Academic
            },
            {
                path: '/learner-internship-project-details',
                name: 'learner-internship-project-details',
                component: InternshipProject
            },
            {
                path: '/learner-skill-certification-details',
                name: 'learner-skill-certification-details',
                component:SkillCertification
            },
            {
            
                path: '/learner-experience-details',
                name: 'learner-experience-details',
                component: Experience
            },
            {
                path: '/learner-extra-curricular-details',
                name: 'learner-extra-curricular-details',
                component: ExtraCurricular
            },
            {
                path: '/learner-publication-details',
                name: 'learner-publication-details',
                component: Publication
            },
            {
                path: '/learner-social-details',
                name: 'learner-social-details',
                component:  Social
            },
            {
                path: '/learner-progress',
                name: 'learner-progress',
                meta: { breadcrumb: `Progress` },
                component: Progress,
            },
            {
                path: '/course-progress',
                name: 'course-progress',
                meta: { breadcrumb: 'Course Progress' },
                component: CourseProgress,
            },
            
            {
                path: '/join-new-course',
                name: 'join-new-course',
                meta: { breadcrumb: 'Join New Course' },
                component: JoinNewCourse,
            },
            {
                path: '/sample',
                name: 'sample',
                meta: { breadcrumb: 'sample' },
                component: Sample,
            },
            {
                path: '/video-training-learner',
                name: 'video-training-learner',
                meta: { breadcrumb: 'Video Training Learner' },
                component: VideoTrainingLearner,
            },
            {
                path: '/courses-catalog',
                name: 'courses-catalog',
                meta: { breadcrumb: 'Courses Catalog' },
                component: CoursesCatalog,
            },
            {
                path: '/learner-course-purchase',
                name: 'learner-course-purchase',
                meta: { breadcrumb: 'Course Purchase' },
                component: CoursePurchase,
            },            
            {
                path: '/course-overview',
                name: 'course-overview',
                meta: { breadcrumb: 'Course Overview' },
                component: CourseOverview,
            },
            {
                path: '/learner-profile',
                name: 'learner-profile',
                component: Profile
            },
            {
                path: '/learner-notification',
                name: 'learner-notification',
                component: Notification
            },
            {
                path: '/learner-messages',
                name: 'learner-messages',
                component: Messages
            },
            
            {
                path: '/my-calendar',
                name: 'my-calendar',
                meta: { breadcrumb: 'My Calendar' },
                component: MyCalendar
            },
            {
                path: '/common-discussion-forum',
                name: 'common-discussion-forum',
                component: CommonDiscussionForum,
                meta: { breadcrumb: 'Discussion Forum' },
            },
            {
                path: '/learner-profile-tabs',
                name: 'learner-profile-tabs',
                component: LearnerProfileTabs
            },
            {
                path: '/learner-skills',
                name: 'learner-skills',
                component: Skills
            },
            {
                path: '/learner-trasactions',
                name: 'learner-trasactions',
                component: LearnerTransactions
            },
            {
                path: '/learner-certificate',
                name: 'learner-certificate',
                component: LearnerCertificate
            },
            {
                path: '/learner-settings',
                name: 'learner-settings',
                component: LearnerSettings
            },
            {
                path: '/learner-Contact-Support',
                name: 'learner-Contact-Support',
                component: ContactSupport,
                meta: { breadcrumb: ` ContactSupport` },
            },
            {
                path: '/learner-jobs',
                name: 'learner-jobs',
                component: LearnerJobs,
                meta: { breadcrumb: `Learner-Jobs` },
                children:[
                    {
                        path: '/learner-career-jet-api',
                        name: 'learner-career-jet-api',
                        component: CareerJet,
                        meta: { breadcrumb: `CareerJetApiJob` },
                    },
                    {
                        path: '/learner-linkedin-api',
                        name: 'learner-linkedin-api',
                        component: Linkedin,
                        meta: { breadcrumb: `LinkedIn` },
                    },
                ]
            },
            

            //   {
            //     path: '/admin-master-configuration',
            //     name: 'admin-master-configuration',
            //     component: MasterConfiguration
            //   },
        ]
    },
    {
        path: '/learner/start-exam',
        name: 'learner-start-exam',
        component: StartExam,
        props: true,
    },
    {
        path: '/learner/test-s  ummary',
        name: 'learner-test-summary',
        component: Result,
        props: true,
    },
    {
        path: '/change-password',
        name: 'change-password',
        component: ChangePassword
    },
    {
        path: '/change-pwd',
        name: 'change-pwd',
        component: Changepwd
    },
    {
        path: '/redis-test',
        name: 'redis-test',
        component: Redistest
    },
    
    

]

export default routes